import cn from 'classnames'

import KeyboardNavigator from 'components/KeyboardNavigator'

import styles from './styles.css'

export default function SearchFor({ onSubmit, onChangeToSubmit, searchQuery }) {
  return (
    <KeyboardNavigator.Item
      active
      activeClassName={styles.SearchSuggestions_activeSubmitSuggestion}
      onSelect={onSubmit}
      onActivate={onChangeToSubmit}
    >
      <div
        className={cn(
          styles.SearchSuggestions_suggestion,
          styles.SearchSuggestions_submitSuggestion,
          styles.SearchSuggestions_ready
        )}
      >
        <div className={styles.hint}>Search for</div>
        <div className={styles.suggestion}>{searchQuery}</div>
        <div className="Icon Icon-keyboard-return" />
      </div>
    </KeyboardNavigator.Item>
  )
}
